var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallSim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5531_34813",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0.5C1.79086 0.5 0 2.29086 0 4.5V17.823C0 18.8839 0.421427 19.9013 1.17157 20.6514L3.84857 23.3284C4.59872 24.0786 5.61613 24.5 6.677 24.5H20C22.2091 24.5 24 22.7091 24 20.5V4.5C24 2.29086 22.2091 0.5 20 0.5H4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84857 23.3284L4.55568 22.6213L3.84857 23.3284ZM1.17157 20.6514L0.464466 21.3585L1.17157 20.6514ZM1 4.5C1 2.84315 2.34315 1.5 4 1.5V-0.5C1.23858 -0.5 -1 1.73858 -1 4.5H1ZM1 17.823V4.5H-1V17.823H1ZM0.464466 21.3585L3.14147 24.0355L4.55568 22.6213L1.87868 19.9443L0.464466 21.3585ZM20 23.5H6.677V25.5H20V23.5ZM23 20.5C23 22.1569 21.6569 23.5 20 23.5V25.5C22.7614 25.5 25 23.2614 25 20.5H23ZM23 4.5V20.5H25V4.5H23ZM20 1.5C21.6569 1.5 23 2.84315 23 4.5H25C25 1.73858 22.7614 -0.5 20 -0.5V1.5ZM4 1.5H20V-0.5H4V1.5ZM3.14147 24.0355C4.07915 24.9732 5.35092 25.5 6.677 25.5V23.5C5.88135 23.5 5.11829 23.1839 4.55568 22.6213L3.14147 24.0355ZM-1 17.823C-1 19.1491 -0.473216 20.4209 0.464466 21.3585L1.87868 19.9443C1.31607 19.3817 1 18.6187 1 17.823H-1Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_5531_34813)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallSim);
export default __webpack_public_path__ + "static/media/small-sim.42526e90abd61045cc240cd43c0c0ea0.svg";
export { ForwardRef as ReactComponent };